// Function to collect the query parameters from the url that are used for the authentication/authorization flow
import selectQueryParameters from "lib/queryParameters/selectQueryParameters";

import { AuthorizeParameters } from "../types/authParameters";
import { UserRegistration } from "../types/userRegistration";

const REQUIRED_PARAMETERS = ["clientId", "redirectUri"] as const;
const OPTIONAL_PARAMETERS = [
  // Authorize parameters
  "responseMode",
  "responseType",
  "scope",
  "state",

  // PrePopulate parameters
  "firstName",
  "lastName",
  "email",

  "transactionToken",
] as const;

type AuthQueryParamData = Partial<
  AuthorizeParameters &
    Omit<UserRegistration, "username" | "password" | "preferredName"> & {
      transactionToken?: string;
    }
>;

// Keeping the auth param data in memory
let authQueryParamData: AuthQueryParamData;

export const setUpAuthQueryParamData = () => {
  const paramData: AuthQueryParamData = selectQueryParameters(
    window.location.search,
    [...REQUIRED_PARAMETERS, ...OPTIONAL_PARAMETERS],
  );

  const missingParams = REQUIRED_PARAMETERS.filter(
    (paramKey) => !paramData[paramKey],
  );

  if (missingParams.length) {
    console.warn(
      `Url is missing the following required query parameter(s): ${missingParams.join(
        ", ",
      )}. The redirect back to the client application may not work as expected.`,
    );
  }

  if (!paramData.state) {
    console.warn(
      `Url is missing the query parameter 'state'. Setting a value for this PIM app, but the value will be useless for the client application the user is redirected to.`,
    );
    paramData.state = `pim_${Date.now()}`;
  }

  authQueryParamData = paramData;
};

const getAuthQueryParamData = () => {
  if (!authQueryParamData) {
    setUpAuthQueryParamData();
  }

  return {
    ...authQueryParamData,
  };
};

export default getAuthQueryParamData;
